module.exports = __webpack_public_path__ + "img/morado.19dd4b42.svg";